export default "__VITE_ASSET__Cah_7W$2__"